import { NgModule } from '@angular/core';
import { AvanoRadioCheckboxGroupComponent } from './avano-radio-checkbox-group.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [AvanoRadioCheckboxGroupComponent],
  exports: [AvanoRadioCheckboxGroupComponent]
})
export class AvanoRadioCheckboxGroupModule { }
